import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

function Home({ t }) {
  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-center min-vh-75">
          <Col lg={8} className="mx-auto text-center">
            <div className="hero-content">
              <h1 className="mb-4">
                <span className="text-gradient">{t.home}</span>
              </h1>
              <p className="lead mb-5 content-wrapper">
                {t.homeContent}
              </p>
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Button 
                  href="#about" 
                  variant="primary" 
                  className="btn-primary rounded-pill px-5 py-3"
                >
                  {t.about}
                </Button>
                <Button 
                  href="#contact" 
                  variant="outline-primary" 
                  className="btn-outline-primary rounded-pill px-5 py-3"
                >
                  {t.contact}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
